import {
	ChainlitAPI,
	IPageInfo,
	IThread,
	IThreadFilters,
} from '@chainlit/react-client'
import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react'

import { getAppBaseUrl } from '@/utils/origin'

interface ThreadsResult {
	data: IThread[]
	pageInfo: IPageInfo
}

interface ChainlitQueryArgs {
	filter?: IThreadFilters
	pageSize: number
}

const chainlitBaseQuery: BaseQueryFn<
	ChainlitQueryArgs,
	ThreadsResult,
	{ error: string; status: string }
> = async ({ pageSize, filter }) => {
	try {
		const baseUrl = `${getAppBaseUrl()}/chainlit`
		const chainLitAPI = new ChainlitAPI(baseUrl, 'webapp')

		const result = await chainLitAPI.listThreads(
			{ first: pageSize },
			{ search: filter?.search, feedback: filter?.feedback },
		)
		return { data: result }
	} catch (error) {
		return {
			error: {
				status: 'CUSTOM_ERROR',
				error:
					error instanceof Error ? error.message : 'Unknown error occurred',
			},
		}
	}
}

export const chainlitApiSlice = createApi({
	reducerPath: 'chainlitApi',
	baseQuery: chainlitBaseQuery,
	endpoints: (builder) => ({
		listThreads: builder.query<ThreadsResult, ChainlitQueryArgs>({
			query: ({ filter, pageSize }) => ({
				filter,
				pageSize,
			}),
		}),
	}),
})

export const { useListThreadsQuery } = chainlitApiSlice
